export default __webpack_public_path__ + "static/media/skill-melodies.c7b46cbb.svg";